import React from 'react'
import moment from 'moment'
import Select from 'react-select'
import HourSelect from "./HourSelect"
import DaySelect from "./DaySelect"
import {Collapse, Button} from "reactstrap"
export default class YourReservationBlue extends React.Component {
    constructor(props) {
        super(props)
        this.start_date = React.createRef()
        this.start_hour = React.createRef()
        this.end_date = React.createRef()
        this.end_hour = React.createRef()
        this.state = {
            pickLocation: {value: this.props.start_location},
            dropLocation: {value: this.props.end_location || this.props.start_location},
            visible: this.props.staticPage ? true : !this.props.layoutMobile
        }
        moment.locale(this.props.locale || 'en')
        if (this.props.staticPage) {
            this.colsClasses = 'col-lg-6 p-0 pr-1 pb-1'
            this.btnColClass = 'col-lg mb-1 mt-3 pr-2'
        } else {
            this.colsClasses = 'col-md-6 col-lg p-0 pr-1 pb-1'
            this.btnColClass = 'col-md col-lg-auto mb-1 mt-3 mt-lg-0 pr-0 pr-lg-2'
        }
    }

    checkRange = (from, to) => {
        if (moment(to).startOf('day').diff(moment(from).startOf('day'), 'days') >= 1) {
            this.setState({hasError: false})
            return true
        }
        this.setState({hasError: true})
        return false
    }

    modifySearch = () => {
        const r = {
            start_location: this.state.pickLocation && this.state.pickLocation.value,
            end_location: this.state.dropLocation && this.state.dropLocation.value || this.state.pickLocation && this.state.pickLocation.value,
            start_hour: this.start_hour.current.state.hour,
            end_hour: this.end_hour.current.state.hour,
            start_date: moment(this.start_date.current.state.date).format("Y-MM-DD"),
            end_date: moment(this.end_date.current.state.date).format("Y-MM-DD")
        }
        if(!this.checkRange(r.start_date, r.end_date)) {
            alert(this.props.t.e_min)
            return
        }
        if(!(parseInt(r.start_location) > 0)) {
            alert(this.props.t.e_pick)
            return
        }
        window.location.href = '/rental_cars/?' +
            'start_date=' + r.start_date +
            '&end_date=' + r.end_date +
            '&start_location=' + r.start_location +
            '&end_location=' + r.end_location +
            '&start_hour=' + r.start_hour +
            '&end_hour=' + r.end_hour +
            '&locale=' + this.props.locale
    }


    renderPickValue = (option) => {
        if (this.state.pick_open)
            return <span>{option.label}</span>
        else
            return <span><i className={'fa fa-map-marker mr-2 text-primary'}/> {option.label}</span>
    }


    renderDropValue = (option) => {
        if (this.state.drop_open)
            return <span>{option.label}</span>
        else
            return <span><i className={'fa fa-map-marker mr-2 text-primary'}/> {option.label}</span>
    }

    renderFilters = () => {
        const placeholder = <span><i className={'fa fa-map-marker mr-2'} /> {this.props.t.pick_empty}</span>
        const { pickLocation, dropLocation } = this.state
        return (
            <div className="mx-2 mx-sm-0">
                <div className={'row small pt-1 car_list'}>
                    <div className={this.colsClasses}>
                        <div className="bg-white" style={{ minHeight: '53px' }}>
                            <div className={'small text-muted ml-2'}>{this.props.t.pick_label}</div>
                            <Select
                                className={'car_list_select'}
                                name={'pick_location_id'}
                                placeholder={placeholder}
                                value={pickLocation && pickLocation.value}
                                onChange={(pickLocation) => {
                                    this.setState({ pickLocation: pickLocation, pickError: false, dropLocation: { value: null } })
                                    localStorage.setItem('start_location', pickLocation && pickLocation.value)
                                }}
                                options={this.props.locations}
                                valueRenderer={this.renderPickValue}
                                clearable={false}
                                style={this.state.pickError ? { 'border': '1px solid red', 'background': '#fff6f6' } : {}}
                                onOpen={() => this.setState({ pick_open: true })}
                                onClose={() => this.setState({ pick_open: false })}
                            />
                        </div>
                    </div>
                    <div className={this.colsClasses}>
                        <div className="bg-white" style={{ minHeight: '53px' }}>
                            <div className={'small text-muted ml-2'}>{this.props.t.return_label}</div>
                            <Select
                                className={'car_list_select'}
                                name={'pick_location_id'}
                                placeholder={placeholder}
                                value={dropLocation && dropLocation.value}
                                onChange={(dropLocation) => {
                                    this.setState({ dropLocation: dropLocation, dropError: false })
                                    localStorage.setItem('end_location', dropLocation && dropLocation.value)
                                }}
                                options={this.props.locations}
                                valueRenderer={this.renderDropValue}
                                clearable={false}
                                style={this.state.dropError ? {
                                    'border': '1px solid red',
                                    'background': '#fff6f6'
                                } : {}}
                                onOpen={() => this.setState({ drop_open: true })}
                                onClose={() => this.setState({ drop_open: false })}
                            />
                        </div>
                    </div>
                    <div className={this.colsClasses}>
                        <div className="bg-white pb-2 px-2 text-truncate" style={{ minHeight: '53px' }}>
                            <div className={'small text-muted'}>{this.props.t.pick_date}</div>
                            <div className={'text-truncate mt-1'}>
                                <DaySelect locale={this.props.locale}
                                    date={this.props.start_date}
                                    id={'start_pick' + (this.props.staticPage ? '_static' : '')}
                                    ref={this.start_date}
                                    onDayChange={(date) => localStorage.setItem('start_date', moment(date).format("YYYY-MM-DD"))}
                                />
                                <span className={'pull-right mt-1'}>
                                    <HourSelect hour={this.props.start_hour} ref={this.start_hour} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={this.colsClasses}>
                        <div className="bg-white pb-2 px-2 text-truncate" style={{ minHeight: '53px' }}>
                            <div className={'small text-muted'}>{this.props.t.return_date}</div>
                            <div className={'text-truncate mt-1'}>
                                <DaySelect locale={this.props.locale}
                                    date={this.props.end_date}
                                    id={'end_pick' + (this.props.staticPage ? '_static' : '')}
                                    ref={this.end_date}
                                    onDayChange={(date) => localStorage.setItem('end_date', moment(date).format("YYYY-MM-DD"))}
                                />
                                <span className={'pull-right mt-1'}>
                                    <HourSelect hour={this.props.end_hour} ref={this.end_hour} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={this.btnColClass}>
                        <button className={'btn btn-warning h-100 pull-right'}
                            onClick={this.modifySearch}>{this.props.t.search}</button>
                    </div>
                </div>
            </div>
        )
    }

    renderWide = () => {
        return (
            <div className={'col bg-primary pb-3' + (this.props.staticPage ? ' pt-3' : ' pt-1')}>
                <div className={'container'}>
                    {!this.props.staticPage && <div className='text-white'>{this.props.t.your_res}</div>}
                    {this.renderFilters()}
                </div>
            </div>
        )
    }

    renderMobile = () => {
        return (
            <div className={'col bg-primary py-2'}>
                <div>
                    {!this.props.staticPage && <div className='d-flex justify-content-between align-items-center'>
                        <div className={'text-white'}>
                            {this.state.visible && <div>{this.props.t.your_res}</div>}
                            {!this.state.visible &&
                                <React.Fragment>
                                    <div className={'font-weight-bold'}>{this.props.start_location_name}</div>
                                    <div className='font-size-85'>
                                        {moment(this.props.start_date).format("DD MMMM")} {this.props.start_hour} -
                                        {moment(this.props.end_date).format("DD MMMM")} {this.props.end_hour}
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                        <Button outline color='primary' size='sm' className={'text-white font-weight-bold'} style={{borderColor: 'white'}}
                            onClick={() => {this.setState({visible: !this.state.visible})}}>
                            {this.state.visible ? this.props.t.p_close : this.props.t.p_modify}
                            {' '}
                            <i className={`fa fa-chevron-${this.state.visible ? 'up' : 'down'}`}/>
                        </Button>
                    </div>}
                    <Collapse isOpen={this.state.visible} className='mt-1'>
                        {this.renderFilters()}
                    </Collapse>
                </div>
            </div>
        )
    }


    render() {
        return (
            <div id={'yourReservation'} className="row">
                {this.props.layoutMobile  ? this.renderMobile() : this.renderWide()}
            </div>
        )
    }
}